import React from 'react';
import PropTypes from 'prop-types';
import { get, isNaN } from 'lodash';
import { withFixedSegmentCategory } from '@sparefoot/react-core/segment';
import { formatUSD } from '@sparefoot/react-core/utils/format';

import { H4 } from 'components/core/Typography';
import { Card } from 'components/legacy/Card';
import { Link } from 'components/core/Link';

import './NearbyCitiesComparison.scss';

export const enhance = withFixedSegmentCategory('city comparison sidebar widget interactions');

export function NearbyCitiesComparison({ nearbyCities, searchCity, location }) {
	return (
		<Card className="nearby-cities-comparison">
			<div className="card-content">
				<H4 className="card-title">
					How does self-storage in {location.city} compare to nearby {location.fullState} cities?
				</H4>
				<ul className="nearby-cities">
					{nearbyCities.map((city) => {
						const searchCityAvgPrice = parseInt(get(searchCity, 'averagePrices.10x10.price'));
						const nearbyCityAvgPrice = parseInt(get(city, 'averagePrices.10x10.price'));
						return (
							<li className="nearby-city" key={city.city}>
								<Link
									href={`/${city.uri}`}
									segmentLabel={`${city.city} view them link`}
									className="city-link"
								>
									<strong>{city.city} Self-Storage: </strong>
								</Link>
								{(!!nearbyCityAvgPrice && searchCityAvgPrice) ?
									<span>
										{!isNaN(searchCityAvgPrice) && `With an average price of ${formatUSD(nearbyCityAvgPrice)}, `}
										self-storage is
										{nearbyCityAvgPrice <= searchCityAvgPrice ? ' cheaper ' : ' more expensive '}
										than in {location.city}.
									</span> :
									null
								}
								{' '}
								SelfStorage.com has {city.numFacilities} storage facilities in {city.city}.
							</li>
						);
					})}
				</ul>
			</div>
		</Card>
	);
}

NearbyCitiesComparison.propTypes = {
	nearbyCities: PropTypes.arrayOf(PropTypes.shape({
		city: PropTypes.string,
		uri: PropTypes.string,
		numFacilities: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		averagePrices: PropTypes.object.isRequired
	})).isRequired,
	searchCity: PropTypes.shape({
		averagePrices: PropTypes.object.isRequired
	}).isRequired,
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		fullState: PropTypes.string.isRequired
	}).isRequired
};

export default enhance(NearbyCitiesComparison);
